import { Database } from "lucide-react";
import type { IComparisonRetaguarda } from "src/@types/campaign-comparison";
import { fieldLabel, formatFieldValue } from "./field-format";

interface RetaguardaCardProps {
  retaguarda: IComparisonRetaguarda;
}

export function RetaguardaCard({ retaguarda }: RetaguardaCardProps) {
  const visibleFields = Object.entries(retaguarda.fields).filter(
    ([, value]) => value !== null && value !== undefined && value !== ""
  );

  return (
    <div className="rounded-lg border bg-card p-4">
      <div className="mb-3 flex items-center gap-2">
        <Database className="h-4 w-4 text-muted-foreground" />
        <span className="font-semibold">Retaguarda (VAR Central)</span>
      </div>
      <div className="grid gap-x-8 gap-y-2 sm:grid-cols-2 lg:grid-cols-3">
        {visibleFields.map(([field, value]) => (
          <div key={field} className="flex flex-col">
            <span className="text-xs text-muted-foreground">
              {fieldLabel(field)}
            </span>
            <span className="text-sm font-medium">
              {formatFieldValue(field, value)}
            </span>
          </div>
        ))}
        {retaguarda.itemCount !== undefined && (
          <div className="flex flex-col">
            <span className="text-xs text-muted-foreground">
              Itens cadastrados
            </span>
            <span className="text-sm font-medium">{retaguarda.itemCount}</span>
          </div>
        )}
      </div>
    </div>
  );
}
